// Centralized translations for in7sekunden (DE / EN)
// Keep content calm, professional, free of emojis and marketing clichés.

export const translations = {
  de: {
    brand: {
      name: "in7sekunden",
      tagline: "Sichtbarkeit direkt am Kundenkontakt.",
    },
    nav: {
      start: "Start",
      product: "Aufsteller",
      bestseller: "Produkte",
      personalization: "Personalisierung",
      bulk: "Großmengen",
      reputation: "Reputation Service",
      faq: "FAQ",
      contact: "Kontakt",
      cta: "Unverbindlich anfragen",
      menu: "Menü",
      close: "Schließen",
    },
    hero: {
      eyebrow: "NFC-Aufsteller für lokale Unternehmen",
      h1a: "Mehr Bewertungen & Follower.",
      h1b: "Und das in 7 Sekunden.",
      sub: "Mit einem NFC-Aufsteller führen Sie Ihre Kunden direkt zur Bewertung, zu Instagram, TikTok, WhatsApp, Ihrem Wunschlink – oder sogar zu einer schnellen Zahlung. Ohne Suchen, ohne Tippen, ohne Umwege.",
      cta1: "Jetzt Aufsteller anfragen",
      cta2: "So funktioniert es",
      metric1: "Sekunden vom Tap zur Aktion",
      metric2: "Ohne App, ohne Strom",
      metric3: "Zwei Wege, ein Aufsteller",
    },
    problem: {
      overline: "Warum es meist nicht passiert",
      title: "Der Moment im Geschäft ist entscheidend.",
      body: "Viele Kunden sind zufrieden, aber sie bewerten nicht. Viele würden folgen, aber sie suchen nicht aktiv nach dem Profil. Genau in diesem Moment – vor Ort, mit dem Smartphone in der Hand – muss es einfach sein. Einmal tippen. Fertig.",
      points: [
        "Bewertungen bleiben aus, obwohl Kunden zufrieden sind.",
        "Social-Profile werden nicht gefunden oder nicht gesucht.",
        "Der Weg zum Link ist länger als die Aufmerksamkeit reicht.",
      ],
    },
    solution: {
      overline: "Ein Aufsteller. Viele Wege.",
      title: "Ein Tap. Direkt dort, wo Sie Ihre Kunden sehen.",
      body: "Der Aufsteller steht sichtbar an der Theke, am Empfang, auf dem Tisch, an der Kasse oder im Behandlungsraum. Der Kunde hält sein Smartphone daran oder scannt den QR-Code. Danach öffnet sich direkt der gewünschte Link.",
      platforms: [
        "Google-Bewertung",
        "Trustpilot",
        "Instagram",
        "TikTok",
        "Facebook",
        "WhatsApp",
        "Webseite",
        "Terminbuchung",
      ],
    },
    how: {
      overline: "So funktioniert es",
      title: "Drei Schritte. Kein Umweg.",
      steps: [
        {
          n: "01",
          title: "Aufsteller platzieren",
          body: "An Theke, Empfang, Tisch, Kasse oder im Behandlungsraum – gut sichtbar, ohne Strom oder WLAN.",
        },
        {
          n: "02",
          title: "Kunde scannt oder tippt",
          body: "Mit NFC-Handy kurz an den Aufsteller halten oder den QR-Code scannen. Ohne App.",
        },
        {
          n: "03",
          title: "Direkt zur Aktion",
          body: "Bewertung abgeben, folgen oder kontaktieren – in wenigen Sekunden, ohne Suchen.",
        },
      ],
    },
    benefits: {
      overline: "Vorteile",
      title: "Durchdacht für den Kundenkontakt.",
      items: [
        { title: "Kein Suchen nach Profilen", body: "Der richtige Link wird direkt geöffnet." },
        { title: "Keine App notwendig", body: "Funktioniert mit jedem modernen Smartphone." },
        { title: "Kein Strom, kein WLAN, keine Batterie", body: "Der Aufsteller arbeitet passiv." },
        { title: "NFC und QR-Code kombiniert", body: "Beide Wege parallel verfügbar." },
        { title: "Für viele Branchen geeignet", body: "Vom Café bis zur Arztpraxis." },
        { title: "Bewertungen, Follower, Kontakte", body: "Ein Aufsteller, viele Anwendungsfälle." },
        { title: "Sichtbar am Kundenkontakt", body: "Genau dort, wo Entscheidungen entstehen." },
        { title: "Auch für ältere Kunden einfach", body: "Der Weg ist klar vorgegeben." },
      ],
    },
    industries: {
      overline: "Für Ihre Branche gedacht",
      title: "Wo sich der Aufsteller natürlich einfügt.",
      items: [
        { name: "Arztpraxen", body: "Am Empfang für Bewertungen nach dem Termin." },
        { name: "Kosmetikstudios", body: "Am Spiegel oder Tresen für Instagram-Follows." },
        { name: "Nagelstudios", body: "Am Kassenplatz für Google-Bewertungen." },
        { name: "Cafés", body: "Auf dem Tisch für schnelle Bewertungen beim Zahlen." },
        { name: "Restaurants", body: "An der Rechnungsmappe oder am Ausgang." },
        { name: "Friseure", body: "Am Bedienplatz für Bewertungen und Social Media." },
        { name: "Hotels", body: "An der Rezeption für Trustpilot und Google." },
        { name: "Einzelhandel", body: "An der Kasse für Follows und Newsletter." },
        { name: "Fitnessstudios", body: "Am Empfang für Bewertungen und Community." },
        { name: "Dienstleister", body: "Im Beratungsraum für Kontakt und Feedback." },
      ],
    },
    personalization: {
      overline: "Personalisierung",
      title: "Ein sichtbares kleines System in Ihrem Geschäft.",
      body: "Die Aufsteller können optisch an Ihr Unternehmen angepasst werden. So entsteht nicht nur ein Produkt, sondern ein stimmiges kleines System – platziert genau dort, wo Entscheidungen entstehen.",
      items: [
        "Mit Logo",
        "Mit Wunschfarbe",
        "Mit QR-Code",
        "Mit NFC-Link",
        "Für verschiedene Standorte",
        "Für einzelne Mitarbeiter",
        "Für verschiedene Plattformen",
        "Für Empfang, Kasse, Tisch oder Behandlungsraum",
      ],
      cta: "Personalisierung anfragen",
    },
    bulk: {
      overline: "Großmengen & Standorte",
      title: "Für mehrere Filialen, Räume oder Teams.",
      body: "Für größere Stückzahlen erstellen wir eine passende Lösung – abgestimmt auf Ihre Filialen, Theken, Behandlungsräume oder Teams. Einheitliches Design, klare Zuordnung, einfache Nachbestellung.",
      points: [
        { k: "Filialen", v: "Einheitliche Gestaltung über alle Standorte." },
        { k: "Teams", v: "Individuelle Aufsteller pro Mitarbeiter:in möglich." },
        { k: "Räume", v: "Separate Aufsteller je Tisch, Theke oder Raum." },
      ],
      tiersTitle: "Mengenstaffel (Beispiel)",
      tiersNote: "Beispielkonditionen. Die finalen Staffelpreise hängen von Motiv, Personalisierung und Stückzahl ab. Wir erstellen Ihnen gerne ein unverbindliches Angebot.",
      tiers: [
        { qty: "10 Stück", price: "19,90 € / Stück", body: "Für mehrere Tische, Kassen oder Empfangsbereiche an einem Standort." },
        { qty: "50 Stück", price: "14,90 € / Stück", body: "Für Filialen, Praxisketten und mittlere Standortstrukturen." },
        { qty: "100+ Stück", price: "9,90 € / Stück", body: "Für größere Rollouts, Ketten und umfangreiche Unternehmensbestellungen." },
      ],
      cta: "Mengenanfrage senden",
    },
    reputation: {
      overline: "Reputation Service",
      title: "Bewertungen sammeln. Und bestehende Bewertungen professionell managen.",
      lead: "Der Aufsteller sammelt neue, ehrliche Bewertungen direkt am Kundenkontakt. Für alles, was darüber hinausgeht – negative Bewertungen, Google-, Trustpilot- oder Social-Media-Reputation – arbeiten wir mit der Schwesterplattform online-bewertungsmanagement.de.",
      body: "Dort erhalten Sie auf Wunsch zusätzliche, strukturierte administrative Unterstützung bei der Einreichung negativer Bewertungen über die offiziellen Plattformwege – für Google, Trustpilot und relevante Social-Media-Profile. Kombiniert mit den in7sekunden-Aufstellern entsteht ein rundes Paket: mehr neue Bewertungen aktiv einsammeln und bestehende Bewertungen professionell betreuen.",
      packageTitle: "Das Komplettpaket",
      packageItems: [
        { k: "Aktiv sammeln", v: "NFC-Aufsteller von in7sekunden direkt am Kundenkontakt." },
        { k: "Professionell managen", v: "Reputation-Service für Google, Trustpilot und Social Media über online-bewertungsmanagement.de." },
        { k: "Durchgängig", v: "Beide Seiten sind miteinander verbunden – ein System, klare Zuständigkeiten." },
      ],
      note: "Keine Garantie auf Entfernung von Bewertungen. Keine juristische Beratung. Die Entscheidung über eine Entfernung liegt stets bei der jeweiligen Plattform. Reputation-Leistungen werden über die Schwesterplattform online-bewertungsmanagement.de erbracht.",
      cta: "Reputation Service anfragen",
      external: "Zu online-bewertungsmanagement.de",
      externalUrl: "https://www.online-bewertungsmanagement.de",
    },
    showcase: {
      overline: "Der Aufsteller",
      title: "Unscheinbar auf der Theke. Präzise in der Wirkung.",
      body: "Drei Einsatzorte, ein Prinzip. Der Aufsteller fügt sich in moderne Praxis-, Gastronomie- und Retail-Umgebungen natürlich ein und wirkt nicht wie ein Werbe-Accessoire.",
      tiles: [
        { title: "Am Empfang", body: "Sichtbar auf der Theke – ideal für Bewertungen direkt nach dem Termin." },
        { title: "Auf dem Tisch", body: "Im Gastraum platziert – der Kunde tappt oder scannt beim Bezahlen." },
        { title: "Pro Plattform", body: "Mit Ihrer Wunschplattform – Google, Instagram, TikTok, WhatsApp und mehr." },
      ],
      replaceHint: "",
    },
    bestseller: {
      overline: "Varianten",
      title: "Die Aufsteller – passend zu Ziel und Standort.",
      body: "Mehrere Editionen für unterschiedliche Plattformen und Standorte – alle liefern dasselbe Ergebnis: eine klare Geste, einen Tap, eine Aktion.",
      noticeTitle: "Wichtiger Hinweis",
      noticeBody: "Sie sehen hier nur die Preisübersicht. Ihr gewünschtes Paket wählen Sie erst unten auf der Bezahlseite. Die Personalisierung erfolgt anschließend auf der Danke-Seite nach der Bezahlung.",
      priceLabel: "ab",
      detailsCta: "Details ansehen",
      popularBadge: "Beliebt",
      packagesTitle: "Paket-Übersicht",
      packagesNote: "Paketpreise verstehen sich inkl. NFC-Chip, QR-Code und Link-Einrichtung. Personalisierung wird nach der Bezahlung auf der Danke-Seite konfiguriert.",
      packages: [
        { qty: 1, label: "1 Aufsteller", price: "24,90 €", body: "Für einen Standort, eine Theke oder einen Tisch." },
        { qty: 2, label: "2 Aufsteller", price: "49,80 €", body: "Für zwei Kontaktpunkte – z. B. Empfang und Tresen." },
        { qty: 3, label: "3 Aufsteller", price: "70,00 €", badge: "Beliebt", body: "Für mehrere Räume oder Mitarbeiterplätze – mit kleinem Mengenvorteil." },
      ],
      pickPackage: "Paket auswählen",
      priceNote: "Preis pro Stück. Staffelpreise ab 10 Stück. Inkl. NFC-Chip, QR-Code und Link-Einrichtung.",
      cta: "Pakete entdecken",
      ctaCustom: "Variante anfragen",
      items: [
        {
          tag: "Google-Bewertung",
          title: "Google Aufsteller – White Edition",
          body: "Hell, zurückhaltend, freundlich. Für Empfänge, Praxen und moderne Ladenlokale mit hellem Interieur.",
          price: "24,90 €",
          image: "stand-2",
          slug: "google-white",
          inquiryValue: "Google White Edition",
          popular: true,
        },
        {
          tag: "Google-Bewertung",
          title: "Google Aufsteller – Black Edition",
          body: "Dunkel, ruhig, hochwertig. Für Studios, Hotels und Standorte mit warmem, gedecktem Ambiente.",
          price: "24,90 €",
          image: "stand-1",
          slug: "google-black",
          inquiryValue: "Google Black Edition",
        },
        {
          tag: "Instagram-Follow",
          title: "Instagram Aufsteller – Gradient Edition",
          body: "Farbig, aufmerksamkeitsstark, jung. Für Cafés, Kosmetikstudios und visuelle Marken am Point of Contact.",
          price: "24,90 €",
          image: "stand-3",
          slug: "instagram-gradient",
          inquiryValue: "Instagram Gradient Edition",
        },
        {
          tag: "Facebook-Follower",
          title: "Facebook Aufsteller – Blue Edition",
          body: "Klar, freundlich, community-nah. Für Vereine, Ladengeschäfte und Standorte, die auf aktive Facebook-Seiten setzen.",
          price: "24,90 €",
          image: "stand-4",
          slug: "facebook-blue",
          inquiryValue: "Facebook Blue Edition",
        },
        {
          tag: "TikTok-Follow",
          title: "TikTok Aufsteller – Black Edition",
          body: "Dunkel, ruhig, hochwertig. Für Bars, Studios und Marken mit Fokus auf Reels und Kurzvideo-Content.",
          price: "24,90 €",
          image: "stand-5",
          slug: "tiktok-neon",
          inquiryValue: "TikTok Black Edition",
        },
        {
          tag: "Zahlung",
          title: "PayPal Aufsteller – Pay Edition",
          body: "Für direkte Zahlungen am Tresen. Kunde scannt – die PayPal.me-Seite öffnet mit Ihrem Betrag oder Ihrer Adresse.",
          price: "24,90 €",
          image: "stand-6",
          slug: "paypal-pay",
          inquiryValue: "PayPal Pay Edition",
        },
        {
          tag: "WhatsApp-Chat",
          title: "WhatsApp Aufsteller – Chat Edition",
          body: "Direkter Draht zum Kunden. Tap öffnet einen vorbereiteten WhatsApp-Chat – ideal für Terminanfragen und Rückfragen.",
          price: "24,90 €",
          image: "stand-7",
          slug: "whatsapp-chat",
          inquiryValue: "WhatsApp Chat Edition",
          popular: true,
        },
        {
          tag: "Wunsch-Plattform",
          title: "Custom Aufsteller – Ihr Link",
          body: "Trustpilot, Webseite, Terminbuchung, Newsletter oder mehrere Links: Wir setzen jede gewünschte Variante um.",
          price: "auf Anfrage",
          image: "custom",
          slug: "custom",
          inquiryValue: "Custom Edition",
          custom: true,
        },
      ],
    },
    faq: {
      overline: "FAQ",
      title: "Häufig gestellte Fragen.",
      items: [
        {
          q: "Wie funktioniert der Aufsteller?",
          a: "Der Aufsteller enthält einen NFC-Chip und einen QR-Code. Der Kunde hält sein Smartphone daran oder scannt den Code – der gewünschte Link öffnet sich direkt.",
        },
        {
          q: "Braucht der Aufsteller Strom?",
          a: "Nein. Der Aufsteller arbeitet passiv, ohne Strom, ohne WLAN und ohne Batterie.",
        },
        {
          q: "Funktioniert das mit jedem Handy?",
          a: "Nahezu alle modernen Smartphones unterstützen NFC. Für alle anderen Geräte steht der QR-Code bereit.",
        },
        {
          q: "Was ist, wenn NFC nicht funktioniert?",
          a: "Dann nutzt der Kunde einfach den QR-Code. Beide Wege sind immer auf dem Aufsteller vorhanden.",
        },
        {
          q: "Kann ich den Aufsteller mit meinem Logo bekommen?",
          a: "Ja. Der Aufsteller kann mit Ihrem Logo, Ihrer Wunschfarbe und Ihrem Schriftzug personalisiert werden.",
        },
        {
          q: "Kann ich verschiedene Links nutzen?",
          a: "Ja. Möglich sind zum Beispiel Google-Bewertung, Trustpilot, Instagram, TikTok, Facebook, WhatsApp, Ihre Webseite oder eine Terminbuchung.",
        },
        {
          q: "Ist das auch für mehrere Standorte möglich?",
          a: "Ja. Für mehrere Filialen, Räume oder Teams erstellen wir eine passende, einheitliche Lösung.",
        },
        {
          q: "Kann ich Google-Bewertungen und Instagram kombinieren?",
          a: "Ja. Sie können Links kombinieren oder verschiedene Aufsteller für unterschiedliche Zwecke einsetzen.",
        },
        {
          q: "Unterstützen Sie auch bei negativen Bewertungen?",
          a: "Wir unterstützen bei der strukturierten administrativen Einreichung über die offiziellen Plattformwege. Die Entscheidung über eine Entfernung liegt bei der jeweiligen Plattform.",
        },
      ],
    },
    moreServices: {
      overline: "Mehr für Ihr Business",
      title: "Wenn gewünscht: Digital Marketing und Webseite – aus einer Hand.",
      lead: "Die Aufsteller sind ein präziser Baustein. Wer mehr Sichtbarkeit aufbauen möchte, bekommt von uns auf Wunsch das komplette Paket: digitales Marketing, Social-Media-Aufbau und eine eigene Webseite.",
      body: "Diese Leistungen erbringen wir über die Schwesterplattform femmesonlinebusiness.com. Dort entstehen Ihre Online-Auftritte, Kampagnen und Content-Strategien – sauber abgestimmt auf das, was Sie mit den Aufstellern offline ohnehin schon einsammeln.",
      items: [
        { title: "Digital Marketing", body: "Social Media, Performance Ads und Content – aufgebaut auf Ihrem realen Kundenkontakt." },
        { title: "Eigene Webseite", body: "Individuell konzipiert, schnell, klar – auf Wunsch inklusive Pflege und Hosting." },
        { title: "Online-Sichtbarkeit", body: "Profile, Suchmaschinen-Basis, lokale Auffindbarkeit – als stimmiges Gesamtbild." },
      ],
      note: "Die Webseite, auf der Sie sich gerade befinden, ist auf NFC-Aufsteller spezialisiert. Marketing- und Webseiten-Leistungen werden separat über femmesonlinebusiness.com angeboten und beauftragt.",
      cta: "Beratung anfragen",
      external: "Zu femmesonlinebusiness.com",
      externalUrl: "https://www.femmesonlinebusiness.com",
    },
    testimonials: {
      overline: "Kundenstimmen",
      title: "Wie Unternehmen die Aufsteller im Alltag einsetzen.",
      body: "Erste Rückmeldungen aus Praxen, Studios und Gastronomie. Ersetzen Sie diese Platzhalter gerne durch eigene Kundenzitate.",
      placeholder: "Wird bereits für Praxen, Studios und Gastronomie vorbereitet",
      items: [
        {
          quote: "Der Aufsteller fügt sich ruhig an den Empfang ein. Die ersten Bewertungen kamen in den ersten Tagen, weil Kunden den Tap direkt nach dem Termin nutzen – ohne dass wir aktiv danach fragen müssen.",
          name: "[Name]",
          role: "Arztpraxis",
          product: "Google Aufsteller – White Edition",
        },
        {
          quote: "Wir haben den Instagram-Aufsteller auf den Tischen im Café platziert. Mehr Follower, weniger Erklären – das passt einfach zu einer Gäste-Situation, in der das Handy ohnehin in der Hand liegt.",
          name: "[Name]",
          role: "Café",
          product: "Instagram Aufsteller – Gradient Edition",
        },
      ],
    },
    finalCta: {
      overline: "Jetzt starten",
      title: "Bereit, den Moment am Empfang in mehr Sichtbarkeit zu verwandeln?",
      body: "Wählen Sie eine passende Variante oder stellen Sie uns Ihre Anforderungen – wir melden uns mit einem klaren Vorschlag zurück.",
      points: [
        "Passende Variante für Ihren Standort",
        "Mengenlösung für mehrere Kontaktpunkte",
        "Kombinierbar mit dem Reputation Service",
      ],
      cta1: "Unverbindlich anfragen",
      cta2: "WhatsApp öffnen",
    },
    contact: {
      overline: "Kontakt",
      title: "Fragen, Sonderwünsche oder größere Bestellung?",
      body: "Schreiben Sie uns direkt. Wir helfen bei der passenden Variante, bei Branding-Wünschen, größeren Mengen oder beim zusätzlichen Reputation Service.",
      whatsapp: "WhatsApp öffnen",
      send: "Anfrage senden",
      sending: "Wird gesendet …",
      form: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefon (optional)",
        company: "Unternehmen (optional)",
        industry: "Branche",
        industryPlaceholder: "Bitte wählen",
        quantity: "Menge",
        quantityPlaceholder: "Bitte wählen",
        message: "Ihre Nachricht",
        type: "Anliegen",
        typeGeneral: "Allgemeine Anfrage",
        typePersonalization: "Personalisierung",
        typeBulk: "Großmenge / Mehrere Standorte",
        typeReputation: "Reputation Service",
        privacy: "Mit dem Absenden stimmen Sie der Verarbeitung Ihrer Angaben für die Bearbeitung Ihrer Anfrage zu.",
        success: "Vielen Dank. Wir melden uns zeitnah bei Ihnen.",
        error: "Da ist etwas schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt.",
        required: "Pflichtfeld",
        invalidEmail: "Bitte gültige E-Mail-Adresse angeben",
      },
      quantities: ["1 – 5 Stück", "6 – 20 Stück", "21 – 100 Stück", "100+ Stück"],
    },
    footer: {
      tagline: "Sichtbarkeit direkt am Kundenkontakt.",
      nav: "Navigation",
      legal: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
      emailPrivacy: "Datenschutz E-Mail-Signatur",
      rights: "Alle Rechte vorbehalten.",
    },
    common: {
      learnMore: "Mehr erfahren",
      lang: "Sprache",
    },
  },
  en: {
    brand: {
      name: "in7sekunden",
      tagline: "Visibility right at the point of customer contact.",
    },
    nav: {
      start: "Home",
      product: "Stands",
      bestseller: "Products",
      personalization: "Personalization",
      bulk: "Bulk",
      reputation: "Reputation Service",
      faq: "FAQ",
      contact: "Contact",
      cta: "Request info",
      menu: "Menu",
      close: "Close",
    },
    hero: {
      eyebrow: "NFC stands for local businesses",
      h1a: "More reviews & followers.",
      h1b: "In just 7 seconds.",
      sub: "With a single NFC stand your customers go straight to your review page, Instagram, TikTok, WhatsApp, your custom link – or even a quick payment. No searching, no typing, no detours.",
      cta1: "Request a stand",
      cta2: "How it works",
      metric1: "Seconds from tap to action",
      metric2: "No app, no power",
      metric3: "Two paths, one stand",
    },
    problem: {
      overline: "Why it rarely happens on its own",
      title: "The in-store moment is the one that matters.",
      body: "Many customers are happy, but they don't leave a review. Many would follow you, but they won't go looking for your profile. Right there, phone in hand, it has to be simple. One tap and done.",
      points: [
        "Reviews don't get written, even from satisfied customers.",
        "Social profiles are not searched or not found.",
        "The path to the link is longer than attention lasts.",
      ],
    },
    solution: {
      overline: "One stand. Many destinations.",
      title: "One tap. Right where you meet your customers.",
      body: "The stand sits visibly at the counter, reception desk, table, checkout or treatment room. Customers tap their phone or scan the QR code – the link you chose opens instantly.",
      platforms: [
        "Google review",
        "Trustpilot",
        "Instagram",
        "TikTok",
        "Facebook",
        "WhatsApp",
        "Website",
        "Booking",
      ],
    },
    how: {
      overline: "How it works",
      title: "Three steps. No detour.",
      steps: [
        { n: "01", title: "Place the stand", body: "At the counter, reception, table or treatment room – visible, without power or Wi-Fi." },
        { n: "02", title: "Customer taps or scans", body: "Holding their phone to the stand or scanning the QR code. No app required." },
        { n: "03", title: "Straight to the action", body: "Leave a review, follow or get in touch – in seconds, without searching." },
      ],
    },
    benefits: {
      overline: "Benefits",
      title: "Designed for the point of contact.",
      items: [
        { title: "No searching for profiles", body: "The right link opens directly." },
        { title: "No app required", body: "Works with every modern smartphone." },
        { title: "No power, Wi-Fi or battery", body: "The stand works passively." },
        { title: "NFC and QR combined", body: "Both paths available in parallel." },
        { title: "Fits many industries", body: "From cafés to medical practices." },
        { title: "Reviews, followers, contacts", body: "One stand, several use cases." },
        { title: "Visible at the point of contact", body: "Right where decisions happen." },
        { title: "Easy for older customers", body: "The path is clearly laid out." },
      ],
    },
    industries: {
      overline: "Built for your industry",
      title: "Where the stand fits in naturally.",
      items: [
        { name: "Medical practices", body: "At reception for reviews after appointments." },
        { name: "Beauty studios", body: "At the mirror or counter for Instagram follows." },
        { name: "Nail studios", body: "At the checkout for Google reviews." },
        { name: "Cafés", body: "On the table for quick reviews when paying." },
        { name: "Restaurants", body: "With the check folder or at the exit." },
        { name: "Barber shops", body: "At the chair for reviews and social." },
        { name: "Hotels", body: "At reception for Trustpilot and Google." },
        { name: "Retail", body: "At the register for follows and newsletter." },
        { name: "Fitness studios", body: "At reception for reviews and community." },
        { name: "Service providers", body: "In the meeting room for contact and feedback." },
      ],
    },
    personalization: {
      overline: "Personalization",
      title: "A small, visible system inside your business.",
      body: "The stands can be tailored to your business. Not just a product – a small, coherent system placed exactly where decisions are made.",
      items: [
        "With logo",
        "Custom color",
        "With QR code",
        "With NFC link",
        "For multiple locations",
        "For individual team members",
        "For different platforms",
        "For reception, checkout, table or treatment room",
      ],
      cta: "Request personalization",
    },
    bulk: {
      overline: "Bulk & locations",
      title: "For multiple branches, rooms or teams.",
      body: "For larger quantities we create a tailored solution – matched to your branches, counters, treatment rooms or teams. Consistent design, clear allocation, simple reordering.",
      points: [
        { k: "Branches", v: "Consistent design across all locations." },
        { k: "Teams", v: "Individual stands per team member possible." },
        { k: "Rooms", v: "Separate stands per table, counter or room." },
      ],
      tiersTitle: "Volume tiers (example)",
      tiersNote: "Example conditions. Final tier pricing depends on design, personalization and quantity. We'll prepare a non-binding offer.",
      tiers: [
        { qty: "10 pcs", price: "€19.90 / piece", body: "For multiple tables, counters or reception areas at a single location." },
        { qty: "50 pcs", price: "€14.90 / piece", body: "For branches, practice chains and mid-sized structures." },
        { qty: "100+ pcs", price: "€9.90 / piece", body: "For larger roll-outs, chains and comprehensive corporate orders." },
      ],
      cta: "Send bulk request",
    },
    reputation: {
      overline: "Reputation Service",
      title: "Collect new reviews. And professionally manage existing ones.",
      lead: "The stand collects fresh, honest reviews right at the point of customer contact. For everything beyond that – negative reviews, Google, Trustpilot or social media reputation – we work with the sister platform online-bewertungsmanagement.de.",
      body: "On that platform you can additionally request structured administrative support for submitting negative reviews through the official platform channels – for Google, Trustpilot and relevant social media profiles. Combined with in7sekunden stands this creates a complete package: actively collect new reviews and professionally look after the existing ones.",
      packageTitle: "The complete package",
      packageItems: [
        { k: "Actively collect", v: "in7sekunden NFC stands right at the point of customer contact." },
        { k: "Professionally manage", v: "Reputation service for Google, Trustpilot and social media via online-bewertungsmanagement.de." },
        { k: "One system", v: "Both sides are connected – one system, clear responsibilities." },
      ],
      note: "No guarantee of review removal. Not legal advice. The decision on removal always lies with the respective platform. Reputation services are provided by the sister platform online-bewertungsmanagement.de.",
      cta: "Request Reputation Service",
      external: "Visit online-bewertungsmanagement.de",
      externalUrl: "https://www.online-bewertungsmanagement.de",
    },
    showcase: {
      overline: "The stand",
      title: "Discreet on the counter. Precise in effect.",
      body: "Three settings, one principle. The stand sits naturally in modern practice, hospitality and retail environments – never like a promo gadget.",
      tiles: [
        { title: "At reception", body: "Visible on the counter – ideal for reviews right after the appointment." },
        { title: "On the table", body: "Placed in the dining area – customers tap or scan while paying." },
        { title: "Per platform", body: "With your preferred platform – Google, Instagram, TikTok, WhatsApp and more." },
      ],
      replaceHint: "",
    },
    bestseller: {
      overline: "Variants",
      title: "The stands – matched to goal and setting.",
      body: "Multiple editions for different platforms and settings – all delivering the same outcome: a clear gesture, a tap, an action.",
      noticeTitle: "Important note",
      noticeBody: "You only see the price overview here. You'll select your desired package on the checkout page below. Personalization happens afterwards on the thank-you page after payment.",
      priceLabel: "from",
      priceNote: "Price per piece. Volume pricing from 10 pieces. Includes NFC chip, QR code and link setup.",
      cta: "Discover packages",
      ctaCustom: "Request variant",
      detailsCta: "View details",
      popularBadge: "Popular",
      items: [
        {
          tag: "Google review",
          title: "Google Stand – White Edition",
          body: "Light, restrained, friendly. For receptions, practices and modern retail with bright interiors.",
          price: "€24.90",
          image: "stand-2",
          slug: "google-white",
          inquiryValue: "Google White Edition",
          popular: true,
        },
        {
          tag: "Google review",
          title: "Google Stand – Black Edition",
          body: "Dark, calm, premium. For studios, hotels and locations with warm, muted ambience.",
          price: "€24.90",
          image: "stand-1",
          slug: "google-black",
          inquiryValue: "Google Black Edition",
        },
        {
          tag: "Instagram follow",
          title: "Instagram Stand – Gradient Edition",
          body: "Colourful, attention-grabbing, young. For cafés, beauty studios and visual brands at the point of contact.",
          price: "€24.90",
          image: "stand-3",
          slug: "instagram-gradient",
          inquiryValue: "Instagram Gradient Edition",
        },
        {
          tag: "Facebook follower",
          title: "Facebook Stand – Blue Edition",
          body: "Clear, friendly, community-driven. For clubs, local shops and locations that rely on active Facebook pages.",
          price: "€24.90",
          image: "stand-4",
          slug: "facebook-blue",
          inquiryValue: "Facebook Blue Edition",
        },
        {
          tag: "TikTok follow",
          title: "TikTok Stand – Black Edition",
          body: "Dark, calm, premium. For bars, studios and brands focused on reels and short-form video content.",
          price: "€24.90",
          image: "stand-5",
          slug: "tiktok-neon",
          inquiryValue: "TikTok Black Edition",
        },
        {
          tag: "Payment",
          title: "PayPal Stand – Pay Edition",
          body: "For direct payments at the counter. Customers scan – PayPal.me opens with your amount or address.",
          price: "€24.90",
          image: "stand-6",
          slug: "paypal-pay",
          inquiryValue: "PayPal Pay Edition",
        },
        {
          tag: "WhatsApp chat",
          title: "WhatsApp Stand – Chat Edition",
          body: "Direct line to your customers. A tap opens a prepared WhatsApp chat – great for booking questions and follow-ups.",
          price: "€24.90",
          image: "stand-7",
          slug: "whatsapp-chat",
          inquiryValue: "WhatsApp Chat Edition",
          popular: true,
        },
        {
          tag: "Custom platform",
          title: "Custom Stand – Your link",
          body: "Trustpilot, website, booking page, newsletter or multiple links: we'll build the exact variant you need.",
          price: "on request",
          image: "custom",
          slug: "custom",
          inquiryValue: "Custom Edition",
          custom: true,
        },
      ],
    },
    faq: {
      overline: "FAQ",
      title: "Frequently asked questions.",
      items: [
        { q: "How does the stand work?", a: "The stand contains an NFC chip and a QR code. Customers tap their phone or scan the code – the link opens immediately." },
        { q: "Does the stand need power?", a: "No. It works passively, without power, Wi-Fi or battery." },
        { q: "Does it work with every phone?", a: "Almost every modern smartphone supports NFC. For all other devices the QR code is available." },
        { q: "What if NFC doesn't work?", a: "Then customers simply use the QR code. Both options are always present on the stand." },
        { q: "Can I have it with my logo?", a: "Yes. The stand can be personalized with your logo, color and wording." },
        { q: "Can I use different links?", a: "Yes. Possible options include Google review, Trustpilot, Instagram, TikTok, Facebook, WhatsApp, your website or a booking page." },
        { q: "Is it suitable for multiple locations?", a: "Yes. For several branches, rooms or teams we create a tailored, consistent solution." },
        { q: "Can I combine Google reviews and Instagram?", a: "Yes. You can combine links or use separate stands for different purposes." },
        { q: "Do you also support with negative reviews?", a: "We support the structured administrative submission through official platform channels. The decision on removal lies with the respective platform." },
      ],
    },
    moreServices: {
      overline: "More for your business",
      title: "On request: digital marketing and websites – from one source.",
      lead: "The stands are one precise building block. If you want to grow further, we offer the full package: digital marketing, social media build-up and your own website.",
      body: "These services are delivered via the sister platform femmesonlinebusiness.com. That's where your online presence, campaigns and content strategy come to life – cleanly aligned with what the stands already collect offline.",
      items: [
        { title: "Digital marketing", body: "Social media, performance ads and content – built on real customer contact." },
        { title: "Your own website", body: "Individually crafted, fast, clear – including maintenance and hosting if needed." },
        { title: "Online visibility", body: "Profiles, search basics, local discoverability – as one coherent picture." },
      ],
      note: "The website you are on is dedicated to NFC stands. Marketing and website services are offered and contracted separately via femmesonlinebusiness.com.",
      cta: "Request consultation",
      external: "Visit femmesonlinebusiness.com",
      externalUrl: "https://www.femmesonlinebusiness.com",
    },
    testimonials: {
      overline: "Customer voices",
      title: "How businesses use the stands day-to-day.",
      body: "Early feedback from practices, studios and hospitality. Feel free to replace these placeholders with your own customer quotes.",
      placeholder: "Already being prepared for practices, studios and hospitality",
      items: [
        {
          quote: "The stand sits quietly at reception. The first reviews arrived within days because customers use the tap right after their appointment – without us having to ask.",
          name: "[Name]",
          role: "Medical practice",
          product: "Google Stand – White Edition",
        },
        {
          quote: "We placed the Instagram stand on the café tables. More followers, less explaining – it fits a guest setting where the phone is already in hand.",
          name: "[Name]",
          role: "Café",
          product: "Instagram Stand – Gradient Edition",
        },
      ],
    },
    finalCta: {
      overline: "Get started",
      title: "Ready to turn the counter moment into more visibility?",
      body: "Choose a variant or share your requirements – we'll come back with a clear proposal.",
      points: [
        "Matching variant for your setting",
        "Volume solution for multiple touch points",
        "Combinable with the Reputation Service",
      ],
      cta1: "Request info",
      cta2: "Open WhatsApp",
    },
    contact: {
      overline: "Contact",
      title: "Questions, custom wishes or a larger order?",
      body: "Write to us directly. We'll help you with the right variant, branding wishes, larger quantities or the additional Reputation Service.",
      whatsapp: "Open WhatsApp",
      send: "Send request",
      sending: "Sending …",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone (optional)",
        company: "Company (optional)",
        industry: "Industry",
        industryPlaceholder: "Please choose",
        quantity: "Quantity",
        quantityPlaceholder: "Please choose",
        message: "Your message",
        type: "Topic",
        typeGeneral: "General inquiry",
        typePersonalization: "Personalization",
        typeBulk: "Bulk / multiple locations",
        typeReputation: "Reputation Service",
        privacy: "By submitting, you agree to the processing of your details for handling your inquiry.",
        success: "Thank you. We will get back to you shortly.",
        error: "Something went wrong. Please try again or contact us directly.",
        required: "Required",
        invalidEmail: "Please enter a valid email address",
      },
      quantities: ["1 – 5 pcs", "6 – 20 pcs", "21 – 100 pcs", "100+ pcs"],
    },
    footer: {
      tagline: "Visibility right at the point of customer contact.",
      nav: "Navigation",
      legal: "Legal",
      imprint: "Imprint",
      privacy: "Privacy",
      terms: "Terms",
      emailPrivacy: "Email signature privacy",
      rights: "All rights reserved.",
    },
    common: {
      learnMore: "Learn more",
      lang: "Language",
    },
  },
};

export const SUPPORTED_LANGS = ["de", "en"];
